/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { environment } from 'src/environments/environment';
import { Preferences } from '@capacitor/preferences';

export async function set(key: string, value: any): Promise<void> {
    await Preferences.set({
        key: `${environment.appName}-${key}`,
        value: JSON.stringify(value),
    });
}

export async function get(key: string): Promise<any> {
    let item = await Preferences.get({ key: `${environment.appName}-${key}` });
    try {
        item = JSON.parse(item.value);
        return item;
    } catch (error) {
        return item?.value;
    }
}

export async function remove(key: string): Promise<void> {
    await Preferences.remove({
        key: `${environment.appName}-${key}`,
    });
}
